// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-zengjia[data-v-ef20d358]{font-size:24px;cursor:pointer}.list[data-v-ef20d358]{margin-left:120px}.list li[data-v-ef20d358]{display:flex;align-items:center;margin-bottom:20px}.list li span[data-v-ef20d358]{margin-right:10px}.list li .icon-jianshao[data-v-ef20d358]{color:red;cursor:pointer;font-size:22px;margin-right:10px}.main-table[data-v-ef20d358]{padding:3em 2em 2em 2em;margin-top:1em;border-radius:.3em}[data-v-ef20d358] .el-form-item__content{max-width:400px}", ""]);
// Exports
module.exports = exports;
